


































import { Component, Vue } from "vue-property-decorator";
@Component
export default class service extends Vue {
  gnopen(index: any) {
    this.$toast.fail("功能暂未开放");
  }
}
